import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-white/10 py-6 px-4">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-gray-300">
        <p>&copy; {new Date().getFullYear()} 2Players</p>
        <Link to="/privacy-policy" className="hover:text-white transition">
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}
